if($('#p-inquiry')[0]){
  $('.reset_btn a').on('click',function(e){
    e.preventDefault();
    $("form")[0].reset();
  });


  //店舗セレクトボックス自動抽出
  let l = 8;
  let c = "abcdefghijklmnopqrstuvwxyz0123456789";
  let cl = c.length;
  let param = "";
  for(let i=0; i<l; i++){
      param += c[Math.floor(Math.random()*cl)];
  }
  var shopdataFile = "/corporate/json/upload.json?"+param;
  var json;
  $.get(shopdataFile , function(data){
    json = data;
    storeInit();
	}).fail(function(){
		console.log('店舗データをロードできませんでした。');
	});

  function storeInit(){
    var type = {};
    var outputType = '<option value="" selected="selected">選択してください</option>';
    $.each(json,  function(i ,shopdata){
      shopdata.type = shopdata.type.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
      });
      type[shopdata.type] = true;
		});
    $.each(type,  function(key ,typedata){
      if(typedata == true){
        outputType = outputType + '<option value="'+key+'">'+key+'</option>'
      }
    });
    outputType = outputType + '<option value="その他">その他</option>'
    $('#store_type').html(outputType);
  }

  function storeType(){
    var val = $('#store_type').val();
    var pref = {};
    var outputPref = '<option value="" selected="selected">選択してください</option>';
    var outputName = '<option value="" selected="selected">選択してください</option>';
    var disableType = ['公式オンラインストア','アルペン楽天市場店','アルペングループ ヤフー店','アマゾン','ZOZOTOWN ALPEN / SPORTS DEPO','Wowma! アルペングループ'];
    var otherType = ['その他'];

    //その他の場合は自由入力に
    if(otherType.indexOf(val) !== -1){
      $('#store_pref').attr('name','').parent().hide();
      $('#store_pref_text').val('').attr('name','store_pref').show();
      $('#store_name').attr('name','').parent().hide();
      $('#store_name_text').val('').attr('name','store_name').show();
    }else{
      $('#store_pref').attr('name','store_pref').parent().show();
      $('#store_pref_text').val('').attr('name','').hide();
      $('#store_name').attr('name','store_name').parent().show();
      $('#store_name_text').val('').attr('name','').hide();
    }

    //オンラインストア系はpref, nameをdisableに
    if(disableType.indexOf(val) !== -1){
      $('#store_pref').prop('disabled',true).html(outputPref).parent().addClass('disabled');
      $('#store_name').prop('disabled',true).html(outputName).parent().addClass('disabled');
    }else{
      $('#store_pref').prop('disabled',false).html(outputPref).parent().removeClass('disabled');
      $('#store_name').prop('disabled',false).html(outputName).parent().removeClass('disabled');
    }

    $.each(json,  function(i ,shopdata){
      shopdata.type = shopdata.type.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
          return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
      });
      if(val == shopdata.type){
        pref[shopdata.pref] = true;
      }
		});
    $.each(pref,  function(key ,prefdata){
      if(prefdata == true){
        outputPref = outputPref + '<option value="'+key+'">'+key+'</option>'
      }
    });
    $('#store_pref').html(outputPref);
    $('#store_name').html(outputName);
  }

  function storePref(){
    var valType = $('#store_type').val();
    var valPref = $('#store_pref').val();
    var pref = {};
    var outputName = '<option value="" selected="selected">選択してください</option>';

    //空欄なら無条件でnameも空欄に
    if(valPref == ""){
      $('#store_name').html(outputName);
    }


    $.each(json,  function(i ,shopdata){
      if(valType == shopdata.type && valPref == shopdata.pref){
        outputName = outputName + '<option value="'+shopdata.name+'">'+shopdata.name+'</option>'
      }
		});
    $('#store_name').html(outputName);
  }

  $('#store_type').on('change',function(){
    storeType();
  });

  $('#store_pref').on('change',function(){
    storePref();
  });
  //店舗セレクトボックス自動抽出ここまで

  $(window).on('load',function(){
    setTimeout(function(){
      storeType();
    },100);
  });

  //半角カナを全角カナに
  var hankana2zenkana = function (str) {
    var kanaMap = {
        'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
        'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
        'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
        'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
        'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
        'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
        'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
        'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
        'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
        'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
        'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
        'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
        'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
        'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
        'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
        'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
        'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
        'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
        '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
    };

    var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
    return str
            .replace(reg, function (match) {
                return kanaMap[match];
            })
            .replace(/ﾞ/g, '゛')
            .replace(/ﾟ/g, '゜');
  };

  var contact = {

      requiredTxt : "",
      hiraganaTxt : "<p class='l-form__error'>※ひらがなで入力してください。</p>",
      katakanaTxt : "<p class='l-form__error'>※カタカナで入力してください。</p>",
      zipTxt : "<p class='l-form__error'>※郵便番号を正しく入力して下さい。</p>",
      cardnumberTxt : "<p class='l-form__error'>※13桁の数字を正しく入力して下さい。</p>",
      birthTxt : "<p class='l-form__error'>※8桁の数字を正しく入力して下さい。</p>",
      telTxt : "<p class='l-form__error'>※電話番号を正しく入力して下さい。</p>",
      faxTxt : "<p class='l-form__error'>※FAX番号を正しく入力して下さい。</p>",
      mailTxt : "<p class='l-form__error'>※メールアドレスの形式が異なります。</p>",
      mailcheckTxt : "<p class='l-form__error'>※メールアドレスと一致しません。</p>",
      target : "",
      file : "",
      Validate : "",
      type: "",
      flg : false,
      $f : $("#form"),
      $t : $("#form input,#form select,#form textarea"),
      $r : $("#js__reset"),
      $s : $("#js__submit"),
      $b : $("#js__back"),

      init : function () {

          if ($("#form")[0]) {

              //[ 置換 ]--------------------------------------------------------------------------

              //[ 半角カナを全角カナへ変換 ]
              $('input').change(function () {
                  if ($(this).attr("type") != "text") return;
                  //if (!$(this).attr("id").match(/katakana/g)) return;
                  let txt = $(this).val();
                  $(this).val(hankana2zenkana(txt));
              });
              $('textarea').change(function () {
                  //if (!$(this).attr("id").match(/katakana/g)) return;
                  let txt = $(this).val();
                  $(this).val(hankana2zenkana(txt));
              });

              //[ 半角へ変換 ]
              $('input').change(function () {
                  if ($(this).attr("type") != "text") return;
                  if (!$(this).attr("id").match(/tel|fax|zip|email|email_confirm/g)) return;
                  let txt = $(this).val();
                  let han = txt.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
                      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
                  });
                  $(this).val(han);
              });

              //[ 数字のみ入力 ]
              $('input[type=number]').on('keydown', function (e) {
                  let k = e.keyCode;
                  console.log(k);
                  // 0～9, テンキ―0～9, スペース, backspace, delete, →, ←, 以外は入力キャンセル
                  if (!((k >= 48 && k <= 57) || (k >= 96 && k <= 105) || k == 32 || k == 8 || k == 46 || k == 39 || k == 37)) {
                      return false;
                  }
              });

              contact.$t.blur(function(){
                  //バリデート通す
                  contact.target = $(this);
                  contact.validate(contact.target);
              });

              /* file系 */
              // $('input[type=file]').change(function() {
              //     //バリデート通す
              //     if($(this).prop('files')[0] === undefined){
              //         $(this).parents('.p-input__content-list__input').find('.filetext').remove();
              //         $(this).val('');
              //     }else{
              //         contact.target = $(this);
              //         contact.file = $(this).prop('files')[0].name;
              //         contact.validate(contact.target);
              //     }
              // });
              // $(".js__file-remove").on("click",function(){
              //     $(this).parents('.p-input__content-list__input').find('.filetext').remove();
              //     $(this).parents('.p-input__content-list__input').find('input[type=file]').val('');
              // });

              /* ラジオボタン系 */
              $('input[type=radio]').change(function() {
                  //バリデート通す
                  contact.target = $(this);
                  contact.validate(contact.target);
              });

              contact.$f.submit(function(){
                  contact.target = "all";
                  contact.validate(contact.target);
                  if(contact.flg){
                      //SUBMIT!!!
                  }else{
                    $('html, body').animate({ scrollTop: contact.$f.offset().top - $('#l-header__fixed').outerHeight() }, 'fast');
                      return false;
                  }
              });

              contact.$r.on("click",function(){
                  $("p.l-form__error").remove();
                  $("#form .error").removeClass("error");
                  $("#form").find("[type=text],[type=email],[type=tel],[type=file],select,radio,textarea").val("").end().find(":checked").prop("checked", false);
                  $('html, body').animate({ scrollTop: contact.$f.offset().top - $('#l-header__fixed').outerHeight() }, 'fast');
                  return false;
              });

              contact.$s.on("click",function(){
                  contact.$f.submit();
                  return false;
              });

              contact.$b.on("click",function(e){
                e.preventDefault();
                  history.back();
              });

              $("input[group='check']").on("click",function(){
                  contact.target = $(this);
                  contact.validate(contact.target);
              });

              $("input[group='content_item']").change(function(){
                  contact.type = $(this).data('type');
                  contact.change(contact.type);
                  $("#form span.error").remove();
                  $(".p-input__content-list__text,#form input.error,#form select.error,#form textarea.error").removeClass("error");
                  $('.p-input__content-list__file-inner').find('.filetext,.error').remove();
                  $('input[type=file]').val('');
              });

          }

      },

      validate : function(target) {

          contact.target = target;

          //エラーの初期化
          if (contact.target == "all") {
              $("#form p.l-form__error").remove();
              $(".p-input__content-list__text,#form input.error,#form select.error,#form textarea.error").removeClass("error");
              $('.p-input__content-list__file-inner').find('.filetext,.error').remove();
              contact.Validate = $("[type=text],[type=email],[type=tel],[type=file],select,radio,checkbox,textarea").filter(".js__required");
          } else {
              contact.target.parents('dd').children("p.l-form__error").remove();
              contact.target.removeClass("error");
              contact.target.parents('dd').children().removeClass("error");
              contact.target.parents('.p-input__content-list__file-inner').find('.filetext,.error').remove();
              contact.Validate = contact.target;
          }

          //contact.Validate.each(function(){
          for (let i = contact.Validate.length - 1; i >= 0; i--) {

              let _this = contact.Validate.eq(i);
              contact.requiredTxt = _this.parents('dl').find('.l-inquiry-form__content__label__inner').text();
              //console.log(contact.requiredTxt);

              //必須項目のチェック

              if (_this.hasClass('js__required')) {

                  contact.id = _this.attr("id");
                  //console.log(_this.attr("type"));

                  //ひらがなのチェック
                  if (contact.id.match(/hiragana/g)) {
                      if (_this.val() == "") {
                          _this.parents('dd').append("<p class='l-form__error'>※"+contact.requiredTxt+"を入力してください</p>");
                      } else {
                          if (!_this.val().match(/^[ぁ-ろわをんー 　\r\n\t]*$/)) {
                              _this.parents('dd').append(contact.hiraganaTxt);
                          }
                      }
                  }
                  //カタカナのチェック
                  else if (contact.id.match(/katakana/g)) {
                      if (_this.val() == "") {
                          _this.parents('dd').append("<p class='l-form__error'>※"+contact.requiredTxt+"を入力してください</p>");
                      } else {
                          if (!_this.val().match(/^[ァ-ロワヲンー 　\r\n\t]*$/)) {
                              _this.parents('dd').append(contact.katakanaTxt);
                          }
                      }
                  }
                  //郵便番号のチェック
                  else if (contact.id == "zip") {
                      if (_this.val() == "") {
                          _this.parents('dd').append("<p class='l-form__error'>※"+contact.requiredTxt+"を入力してください</p>");
                      } else {
                          if (!_this.val().match(/^[0-9\-]+$/) || _this.val().length < 7) {
                              _this.parents('dd').append(contact.zipTxt);
                          }
                      }
                  }
                  //メールアドレスのチェック
                  else if (contact.id == "email") {
                      if (_this.val() == "") {
                          _this.parents('dd').append("<p class='l-form__error'>※"+contact.requiredTxt+"を入力してください</p>");
                      } else {
                          if (!_this.val().match(/.+@.+\..+/g)) {
                              _this.parents('dd').append(contact.mailTxt);
                          }
                      }
                  }
                  //メールアドレス確認のチェック
                  else if (contact.id == "emailcheck") {
                      if (_this.val() == "") {
                          _this.parents('dd').append("<p class='l-form__error'>※"+contact.requiredTxt+"を入力してください</p>");
                      } else if (_this.val() != $("input[name=" + _this.attr("name").replace(/^(.+)check$/, "$1") + "]").val()) {
                          _this.parents('dd').append(contact.mailcheckTxt);
                      }
                  }
                  //電話番号のチェック
                  else if (contact.id == "tel" || contact.id == "fax") {
                      if (_this.val() == "") {
                          _this.parents('dd').append("<p class='l-form__error'>※"+contact.requiredTxt+"を入力してください</p>");
                      } else {
                          if (!_this.val().match(/^[0-9\-]+$/) || _this.val().length < 10) {
                            if(contact.id == "tel"){
                              _this.parents('dd').append(contact.telTxt);
                            }else{
                              _this.parents('dd').append(contact.faxTxt);
                            }
                          }
                      }
                  }
                  //カード番号のチェック
                  else if (contact.id == "cardnumber") {
                      if (_this.val() == "") {
                          _this.after("<p class='l-form__error'>※"+contact.requiredTxt+"を入力してください</p>");
                      }else{
                          if (!_this.val().match(/^[0-9\-]+$/) || _this.val().length != 13) {
                              _this.after(contact.cardnumberTxt);
                          }
                      }
                  }
                  //生年月日のチェック
                  else if (contact.id == "birth") {
                      if (_this.val() == "") {
                          _this.after("<p class='l-form__error'>※"+contact.requiredTxt+"を入力してください</p>");
                      }else{
                          if (!_this.val().match(/^[0-9\-]+$/) || _this.val().length != 8) {
                              _this.after(contact.birthTxt);
                          }
                      }
                  }
                  //ファイルのチェック
                  else if (_this.attr("type") == "file") {

                  }
                  //生年月日のチェック
                  else if (contact.id == 'year' || contact.id == 'month' || contact.id == 'day') {
                      if ($('#year').val() == "" || $('#month').val() == "" || $('#day').val() == "") {
                          if(!_this.parents('dd').find('.l-form__error')[0]){
                              _this.parents('dd').append("<p class='l-form__error'>※"+contact.requiredTxt+"を入力してください</p>");
                          }
                      }
                  }
                  //必須項目のチェック
                  else {
                      if (_this.val() == "") {
                          _this.parents('dd').append("<p class='l-form__error'>※"+contact.requiredTxt+"を入力してください</p>");
                      }
                  }
              }

              //必須でない項目も書式等チェック

              else {

                  contact.id = _this.attr("id");
                  //console.log(_this.attr("type"));

                  //ひらがなのチェック
                  if (contact.id.match(/hiragana/g)) {
                      if (_this.val() != "") {
                          if (!_this.val().match(/^[ぁ-ろわをんー 　\r\n\t]*$/)) {
                              _this.parents('dd').append(contact.hiraganaTxt);
                          }
                      }
                  }
                  //カタカナのチェック
                  else if (contact.id.match(/katakana/g)) {
                      if (_this.val() != ""){
                          if (!_this.val().match(/^[ァ-ロワヲンー 　\r\n\t]*$/)) {
                              _this.parents('dd').append(contact.katakanaTxt);
                          }
                      }
                  }
                  //郵便番号のチェック
                  else if (contact.id == "zip") {
                      if (_this.val() != "") {
                          if (!_this.val().match(/^[0-9\-]+$/) || _this.val().length < 7) {
                              _this.parents('dd').append(contact.zipTxt);
                          }
                      }
                  }
                  //メールアドレスのチェック
                  else if (contact.id == "email") {
                      if (_this.val() != "") {
                          if (!_this.val().match(/.+@.+\..+/g)) {
                              _this.parents('dd').append(contact.mailTxt);
                          }
                      }
                  }
                  //メールアドレス確認のチェック
                  else if (contact.id == "emailcheck") {
                      if (_this.val() != "") {
                        if (_this.val() != $("input[name=" + _this.attr("name").replace(/^(.+)check$/, "$1") + "]").val()) {
                          _this.parents('dd').append(contact.mailcheckTxt);
                        }
                      }
                  }
                  //電話番号のチェック
                  else if (contact.id == "tel" || contact.id == "fax") {
                      if (_this.val() != ""){
                          if (!_this.val().match(/^[0-9\-]+$/) || _this.val().length < 10) {
                            if(contact.id == "tel"){
                              _this.parents('dd').append(contact.telTxt);
                            }else{
                              _this.parents('dd').append(contact.faxTxt);
                            }
                          }
                      }
                  }
                  //カード番号のチェック
                  else if (contact.id == "cardnumber") {
                      if (_this.val() != "") {
                          if (!_this.val().match(/^[0-9\-]+$/) || _this.val().length < 13) {
                              _this.after(contact.cardnumberTxt);
                          }
                      }
                  }
                  //ファイルのチェック
                  else if (_this.attr("type") == "file") {

                  }
              }


              if (contact.target == "all") {
                  for (let j = $("p.l-form__error").length - 1; j >= 0; j--) {
                      $("p.l-form__error").parents('dd').children().addClass("error");
                  }
              } else {
                  for (let j = contact.target.parents('dd').children("p.l-form__error").length - 1; j >= 0; j--) {
                      contact.target.parents('dd').children().addClass("error");
                  }
              }

          }

          //checkbox必須
          if (contact.target == "all" || contact.target.attr('name') == 'content_item') {
              if ($("input[group='content_item']:checked").length > 0) {
                  $("input[group='content_item']").parent().parents('dd').children().children("p.l-form__error").remove();
                  $("input[group='content_item']").parent().parents('dd').children().find("input[type=radio]").removeClass("error");
              } else {
                  $("input[group='content_item']").parent().parents('dd').children().append("<p class='l-form__error'>※お問い合わせ項目を入力してください</p>");
                  $("input[group='content_item']").parent().parents('dd').children().find("input[type=radio]").addClass("error");
              }
          }

          //file
          for (let i = $('input[type=file]').length - 1; i >= 0; i--) {
              if ($('input[type=file]').eq(i).prop('files')[0] !== undefined && $('input[type=file]').eq(i).prop('files')[0] !== null && !$('input[type=file]').eq(i).parents('.p-input__content-list__input').find('.filetext')[0]) {
                  var contactFile = $('input[type=file]').eq(i).prop('files')[0].name;
                  $('input[type=file]').eq(i).parents('.p-input__content-list__input').find('.p-input__content-list__file-text').append("<p class='filetext'>" + contactFile + "</p>");
              }
              if ($('input[type=file]').eq(i).prop('files')[0] !== undefined && $('input[type=file]').eq(i).prop('files')[0] !== null) {
                  if ($('input[type=file]').eq(i).prop('files')[0].size > 2000000) {
                      $('input[type=file]').eq(i).parents(".p-input__content-list__input").find(".filetext").addClass("error");
                      if (!$('.p-input__content-list__file-inner').find('span.error')[0]) {
                          $('.p-input__content-list__file-inner').append("<span class='error'>※2MB以下でアップロードして下さい</span>");
                      }
                  }
              }
          }
          // if (contact.target == "all"){
          //     if ($('.p-input__content-list__file-inner').find(".filetext").length===0 && $("input[name=content_item]:checked").val()==='採用について') {
          //         $('.p-input__content-list__file-inner').append("<span class='error'>※ファイルを選択してください</span>");
          //     }
          // }

          if ($("#form p.l-form__error")[0]) {
              contact.flg = false;
          } else {
              contact.flg = true;
          }

          //$("#root").css({"height":$("#js__scroll-body").innerHeight()});

      },

      change : function(target) {

          $('.p-input__content-list__title').removeClass("required");
          $('.change-list').find('input,textarea').removeClass("js__required").prop("disabled", true);
          $('.change-list').css({'display':'none'});
          let required = target + '-r';

          for (let i = $('.change-list').length - 1; i >= 0; i--) {
              if($('.change-list').eq(i).attr('class').match(target)){
                  $('.change-list').eq(i).css({'display':'block'}).find('input,textarea').prop("disabled", false);
                  if($('.change-list').eq(i).attr('class').match(required)){
                      $('.change-list').eq(i).find('.p-input__content-list__title').addClass('required');
                      $('.change-list').eq(i).find('input,textarea').addClass('js__required');
                  }
              }
          }

          setTimeout(function(){
              $("#root").css({"height": $("#js__scroll-body").innerHeight()});
          },300);

      }


  }

  $(window).on("load", function () {

      contact.init();
      for (let i = $('input[type=file]').length - 1; i >= 0; i--) {
          if($('input[type=file]').eq(i).prop('files')[0] !== undefined && $('input[type=file]').eq(i).prop('files')[0] !== null) {
              let contactFile = $('input[type=file]').eq(i).prop('files')[0].name;
              $('input[type=file]').eq(i).parents('.p-input__content-list__input').find('.p-input__content-list__file-text').append("<p class='filetext'>" + contactFile + "</p>");
          }
      }
      // if($("#file1").prop('files')[0] !== undefined){
      //     var contactFile = $("#file").prop('files')[0].name;
      //     $('#file1').parents('.p-input__content-list__input').append("<p class='filetext'>"+contactFile+"</p>");
      // }
      if($("input[name=content_item]").val() !== ''){
          contact.type = $("input[name=content_item]:checked").data('type');
          contact.change(contact.type);
      }

  });

  $(window).on('load resize',function(){
    $('.l-inquiry-index__block__text__tel .number').each(function() {
      var str = $(this).text();
      if($(window).width() <= 750){
        $(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/-/g, '')).append(str + '</a>'));
      }else{
        $(this).html(str);
      }
    });
  });
}
